import react from './place_react';
import docReady from '../../common/docReady';

docReady(() => {
  react();
});
